<template>
  <svg viewBox="0 0 38 39" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
    <g transform="translate(0 .518)" fill="none" fill-rule="evenodd">
      <circle fill="#FFF" cx="19" cy="19" r="19" />
      <path
        d="M15.954 23.41a.24.24 0 0 0 .232-.014l6.517-4.219a.208.208 0 0 0 .097-.174.208.208 0 0 0-.097-.173l-6.517-4.226a.238.238 0 0 0-.233-.012.21.21 0 0 0-.12.19v8.44c0 .079.047.151.121.187Z"
        fill="currentColor"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
